import { render, staticRenderFns } from "./PlayerBanPreview.vue?vue&type=template&id=6b8e2635&scoped=true&"
import script from "./PlayerBanPreview.vue?vue&type=script&lang=js&"
export * from "./PlayerBanPreview.vue?vue&type=script&lang=js&"
import style0 from "./PlayerBanPreview.vue?vue&type=style&index=0&id=6b8e2635&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b8e2635",
  null
  
)

export default component.exports